/**
 * useDocumentTitle, keeps the browser tab title aligned to session + route.
 *
 * Title format (per Ean's 2026-06-03 feedback):
 *   - Logged out               -> "Olytic"
 *   - Logged in, user mode     -> "Olytic, {workspace name}"
 *   - Logged in, admin mode    -> "Olytic, {workspace name}, Admin"
 *
 * Comma separators (not em-dashes) per the no-em-dash style rule.
 *
 * Mount once at the app root inside Router + SessionProvider so it can read
 * the current pathname + session. The effect re-runs on every navigation
 * and every session refresh.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useSession } from './useSession.tsx';

export function TitleManager() {
  const { user } = useSession();
  const location = useLocation();

  useEffect(() => {
    const parts: string[] = ['Olytic'];
    if (user !== null) {
      parts.push(user.account_name);
      if (location.pathname.startsWith('/admin')) {
        parts.push('Admin');
      }
    }
    document.title = parts.join(' - ');
  }, [user, location.pathname]);

  return null;
}
